const Category3DConfig = [
  {
    name: '2-sits soffor',
    images: [
      {url: require('../assets/categories/2-sits_soffor.jpg')}

    ],
  },
  /*{
    name: '2,5-sits soffor',
    images: [
      {url: require('../assets/categories/2.5-sits_soffor.jpg')}
    ],
  },*/
  {
    name: '3-sits soffor',
    images: [
      {url: require('../assets/categories/3-sits_soffor.jpg')}
    ],
  },
  {
    name: '4-sits soffor',
    images: [
      {url: require('../assets/categories/4-sits_soffor.jpg')}
    ],
  },
  {
    name: 'Divansoffa',
    images: [
      {url: require('../assets/categories/divansoffa.jpg')}
    ],
  },
  {
    name: 'Hörnsoffa',
    images: [
      {url: require('../assets/categories/hornsoffa.jpg')}
    ],
  },
  {
    name: 'U-soffa',
    images: [
      {url: require('../assets/categories/u-soffa.jpg')}
    ],
  },
  {
    name: 'Reclinersoffa',
    images: [
      {url: require('../assets/categories/reclinersoffa.jpg')}
    ],
  },
]

export default Category3DConfig;